import { cloneDeep } from 'lodash';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { BaseUI } from '../../base.ui';
import { Nature, ShareHolderType } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { ParentFormDirective } from '../../../directives/parent-form.directive';
import { ShareHolder } from '../../../domain/data';

let nextUniqueId = 0;

@Component({
    selector: 'thr-full-data-form-shareholder-legal',
    templateUrl: './full-data-form-shareholder-legal.component.html',
    styleUrls: ['./full-data-form-shareholder-legal.component.scss']
})
export class FullDataFormShareholderLegalComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public Nature: typeof Nature = Nature;

    public prefix: string;
    public adding = false;
    public editing = false;
    public currentShareHolder: ShareHolder;

    public form: NgForm;
    public isFormValid = false;
    public formStatusChangeSubscription: Subscription;

    @Input()
    shareHolder: ShareHolder;

    @Input()
    min = 25;

    @Input()
    max = 100;

    @Input()
    isDisabled = false;

    @Input()
    showCancel = false;

    @Output()
    cancel: EventEmitter<void> = new EventEmitter();

    @Output()
    save: EventEmitter<void> = new EventEmitter();

    @ViewChild('formDirective')
    formDirective: ParentFormDirective;


    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    ngOnInit() {
        this.prefix = `tfsh-${nextUniqueId++}-`;

        if (this.shareHolder.nature === Nature.COMPANY && this.shareHolder.shareHolders.length === 0) {
            this.onAdd();
        }
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
        this.form = (this.formDirective.controlContainer as NgForm);

        if (this.form) {
            this.formStatusChangeSubscription = this.form.statusChanges.subscribe(() => {
                setTimeout(() => {
                    this.isFormValid = this.form.valid;
                });
            });
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.formStatusChangeSubscription) {
            this.formStatusChangeSubscription.unsubscribe();
        }
    }

    onParentCancel() {
        this.cancel.emit();
    }

    onParentSave() {
        this.save.emit();
    }

    onNatureChange() {
        this.onCancel();

        if (this.shareHolder.nature === Nature.COMPANY && this.shareHolder.shareHolders.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }

    onAdd() {
        this.currentShareHolder = new ShareHolder(ShareHolderType.REPRESENTATIVE);
        this.adding = true;
        this.editing = false;
    }

    onSave() {
        if (this.adding) {
            this.shareHolder.addShareHolder(this.currentShareHolder);
        } else if (this.editing) {
            this.shareHolder.updateShareHolder(this.currentShareHolder);
        }

        this.onCancel();
    }

    onCancel() {
        this.adding = false;
        this.editing = false;
        this.currentShareHolder = undefined;

        this.parentEvents.resize();
    }

    onEdit(shareHolder: ShareHolder) {
        this.currentShareHolder = cloneDeep(shareHolder);
        this.editing = true;
        this.adding = false;
    }

    onRemove(shareHolder: ShareHolder) {
        this.shareHolder.removeShareHolder(shareHolder);

        if (this.currentShareHolder && this.currentShareHolder.id.value === shareHolder.id.value) {
            this.onCancel();
        }

        if (!this.adding && this.shareHolder.shareHolders.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }
}
